// generateStyles.js
export const styleBreakpoints = (blockId, blockSizes, doSiblingMaxWidth, breakPointSizes) => {
  const trimPx = value => value.toString().replace('px', '')
  const n = 'dualaxisspacer'
  const bSize = {
    s: blockSizes['small'],
    m: blockSizes['medium'],
    l: blockSizes['large']
  }

  return `
    #${n}-block--wrapper-${blockId} {
      --${n}-width: ${trimPx(bSize.s.width)}px;
      --${n}-height: ${trimPx(bSize.s.height)}px;
    }
    ${
      doSiblingMaxWidth
        ? `
      #${n}-block--wrapper-${blockId} ~ *:not([id^="${n}-block--wrapper-"]) {
        max-width: var(--${n}-width);
      }
      `
        : ''
    }
    #${n}-block--wrapper-${blockId} .${n}-block {
      width: var(--${n}-width);
      height: var(--${n}-height);
    }
    @media (min-width: ${trimPx(breakPointSizes.tablet)}px) {
      #${n}-block--wrapper-${blockId} .${n}-block {
        --${n}-width: ${trimPx(bSize.m.width)}px;
        --${n}-height: ${trimPx(bSize.m.height)}px;
      }
    }
    @media (min-width: ${trimPx(breakPointSizes.desktop)}px) {
      #${n}-block--wrapper-${blockId} .${n}-block {
        --${n}-width: ${trimPx(bSize.l.width)}px;
        --${n}-height: ${trimPx(bSize.l.height)}px;
      }
    }
  `
}
